// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Xj","title":"Yj","nav":"Zj","flexCell":"_j","facetLink":"ak"};